import React, { useState, useRef, useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Splide, SplideTrack, SplideSlide } from "@splidejs/react-splide"
import SplideArrow from "./splide-arrow"
import Modal from "./modal"

import "@splidejs/react-splide/css/core"
import "../styles/listing-slider.css"

const ListingSlider = ({ images }) => {
  const mainRef = useRef(null)
  const thumbsRef = useRef(null)
  const [showModal, setShowModal] = useState(false)
  const [currentImage, setCurrentImage] = useState(false)

  const handleSlideClick = image => {
    setShowModal(true)
    setCurrentImage(image)
  }

  useEffect(() => {
    if (mainRef.current && thumbsRef.current && thumbsRef.current.splide) {
      console.log(mainRef.current.splide.length)
      mainRef.current.sync(thumbsRef.current.splide)
    }
  })

  return (
    <>
      <Splide
        hasTrack={false}
        options={{
          type: "fade",
          pagination: false,
          rewind: true,
          isNavigation: false,
        }}
        aria-label={"Gallery"}
        ref={mainRef}
      >
        <SplideTrack
          className={
            "h-[320px] sm:h-[400px] md:h-[480px] lg:h-[600px] xl:h-[680px]"
          }
        >
          {images.map(image => (
            <SplideSlide
              className={"h-full cursor-pointer"}
              key={image._key}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                handleSlideClick(image)
              }}
            >
              <GatsbyImage
                image={image.asset.gatsbyImageData}
                className={"w-full h-full object-cover object-center"}
                alt={image.alt}
              />
            </SplideSlide>
          ))}
        </SplideTrack>

        <div className="splide__arrows absolute bottom-0 right-0 flex flex-row">
          <SplideArrow previous />
          <SplideArrow next />
        </div>
      </Splide>

      <div className={"bg-white p-0.5"}>
        <Splide
          options={{
            fixedWidth: 200,
            fixedHeight: 120,
            gap: 2,
            rewind: true,
            isNavigation: true,
            focus: "center",
            pagination: false,
            arrows: false,
            cover: true,
            breakpoints: {
              600: {
                fixedWidth: 100,
                fixedHeight: 60,
              },
            },
          }}
          ref={thumbsRef}
        >
          {images.map(image => (
            <SplideSlide className={"listing-thumbnail"} key={image._key}>
              <GatsbyImage
                image={image.asset.gatsbyImageData}
                className={"w-full h-full object-cover object-center"}
                alt={image.alt}
              />
            </SplideSlide>
          ))}
        </Splide>
      </div>

      <Modal
        id="modal"
        show={showModal}
        handleClose={() => setShowModal(false)}
      >
        {currentImage && (
          <GatsbyImage
            image={currentImage.asset.gatsbyImageData}
            className={"w-full h-full object-cover object-center"}
            alt={currentImage.alt}
          />
        )}
      </Modal>
    </>
  )
}

export default ListingSlider
